
import LogoBannerImg from "./logoBanner.png"

function LogoBanner() {
    return(      
      <div className="logo">
          <img src={LogoBannerImg} alt="placeholder"  />
      </div>
    )
}
 

export default LogoBanner;
